// Sensor images are a website-only concern (the mobile app has none), so they
// stay here and are keyed off the shared registry's groupKey. Everything about
// keys, aliases and names comes from shared/sensors/sensor-registry.json.
import { SENSOR_CHANNELS } from './sensorRegistry.generated';

export const SENSOR_IMAGES = {
  DEFAULT: '/assets/images/sensors/clipart/Default_Sensor.png',
  FORMALDEHYDE: '/assets/images/sensors/clipart/Formaldehyde_Sensor.png',
  PARTICLE_COUNT: '/assets/images/sensors/clipart/Particle_Count_Sensor.png',
  VOC: '/assets/images/sensors/clipart/VOC_Sensor.png',
  CO2: '/assets/images/sensors/clipart/CO2_Sensor.png',
  TEMPERATURE: '/assets/images/sensors/clipart/Default_Sensor.png',
  HUMIDITY: '/assets/images/sensors/clipart/Default_Sensor.png',
  PRESSURE: '/assets/images/sensors/clipart/Pressure_Sensor.png',
  PARTICLES: '/assets/images/sensors/clipart/Particle_Count_Sensor.png',
  CO: '/assets/images/sensors/clipart/Default_Sensor.png',
  MERCAPTAN: '/assets/images/sensors/clipart/Default_Sensor.png',
  NOX: '/assets/images/sensors/clipart/Default_Sensor.png',
};

/** groupKey -> clipart. A group with no entry falls back to DEFAULT. */
const IMAGE_BY_GROUP_KEY = {
  voc: SENSOR_IMAGES.VOC,
  co2: SENSOR_IMAGES.CO2,
  hcho: SENSOR_IMAGES.FORMALDEHYDE,
  co: SENSOR_IMAGES.CO,
  mercaptan: SENSOR_IMAGES.MERCAPTAN,
  nox: SENSOR_IMAGES.NOX,
  temperature: SENSOR_IMAGES.TEMPERATURE,
  temperature_f: SENSOR_IMAGES.TEMPERATURE,
  humidity: SENSOR_IMAGES.HUMIDITY,
  pressure: SENSOR_IMAGES.PRESSURE,
  pm1_0: SENSOR_IMAGES.PARTICLES,
  pm2_5: SENSOR_IMAGES.PARTICLES,
  pm10_0: SENSOR_IMAGES.PARTICLES,
  count_0_3: SENSOR_IMAGES.PARTICLES,
  count_0_5: SENSOR_IMAGES.PARTICLES,
  count_1_0: SENSOR_IMAGES.PARTICLES,
  count_2_5: SENSOR_IMAGES.PARTICLES,
  count_5_0: SENSOR_IMAGES.PARTICLES,
  count_10_0: SENSOR_IMAGES.PARTICLES,
  particle_count_total: SENSOR_IMAGES.PARTICLE_COUNT,
};

export const imageForGroupKey = (groupKey) => IMAGE_BY_GROUP_KEY[groupKey] || SENSOR_IMAGES.DEFAULT;

/** Every lookup token (canonical key + aliases), lowercased -> { name, image }. */
export const SENSOR_CONFIG = SENSOR_CHANNELS.reduce((acc, channel) => {
  const entry = { name: channel.shortName, image: imageForGroupKey(channel.groupKey) };
  [channel.key, ...channel.aliases].forEach((token) => {
    acc[token.toLowerCase()] = entry;
  });
  return acc;
}, {});

/** Display name -> every lookup token that resolves to it. */
export const SENSOR_GROUPS = SENSOR_CHANNELS.reduce((acc, channel) => {
  const tokens = [channel.key, ...channel.aliases].map((token) => token.toLowerCase());
  acc[channel.shortName] = [...(acc[channel.shortName] || []), ...tokens];
  return acc;
}, {});
